/* eslint-disable @typescript-eslint/no-explicit-any */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker не поддерживается');
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('SW registered:', reg);
      })
      .catch((err) => {
        console.error('SW registration failed:', err);
      });
  });
}

export function sendMessageToSW(message: any) {
  if (!navigator.serviceWorker.controller) return;

  navigator.serviceWorker.controller.postMessage(message);
}

export function listenForSWUpdates() {
  if (!navigator.serviceWorker) return;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('[SW] controller changed');
    window.location.reload();
  });
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    throw new Error('Браузер не поддерживает Notification API');
  }

  const permission = await Notification.requestPermission();

  if (permission !== 'granted') {
    throw new Error('Пользователь не разрешил уведомления');
  }

  return permission;
}

function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function arePushKeysEqual(currentKey: ArrayBuffer | null, targetKey: Uint8Array): boolean {
  if (!currentKey) return false;

  const currentKeyBytes = new Uint8Array(currentKey);
  if (currentKeyBytes.length !== targetKey.length) return false;

  return currentKeyBytes.every((byte, index) => byte === targetKey[index]);
}

export async function subscribeToPush(vapidPublicKey: string) {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker не поддерживается');
  }

  const registration = await navigator.serviceWorker.ready;
  const targetApplicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
  const existingSubscription = await registration.pushManager.getSubscription();

  if (existingSubscription) {
    const currentApplicationServerKey = existingSubscription.options?.applicationServerKey;

    if (arePushKeysEqual(currentApplicationServerKey, targetApplicationServerKey)) {
      return existingSubscription;
    }

    await existingSubscription.unsubscribe();
  }

  await requestNotificationPermission();

  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: targetApplicationServerKey,
  });
}

export async function unsubscribeFromPush() {
  if (!('serviceWorker' in navigator)) return false;

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();

  if (!subscription) return false;

  return subscription.unsubscribe();
}
